import React from 'react';
import { FormBuilder } from 'commons-ui';
import { createFormFieldConfig, FORM_LAYOUT_CONFIG, validationSchema } from '../../utils/formConfig';
import useCreate from './useCreate';

const CreateExperiment: React.FC<{}> = () => {
	const { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader, fetchSelectOptions } = useCreate();

	const fieldConfig = createFormFieldConfig(fetchSelectOptions, false);

	return (
		<FormBuilder
			data={data}
			mode='create'
			showLoader={showLoader}
			handleFormSubmit={handleFormSubmit}
			handleFormCancel={handleFormCancel}
			validationSchema={validationSchema}
			setShowLoader={setShowLoader}
			fieldConfig={fieldConfig}
			layoutConfig={FORM_LAYOUT_CONFIG}
		/>
	);
};

export default CreateExperiment;
